import { render, staticRenderFns } from "./AddUpdate.vue?vue&type=template&id=170a617e"
import script from "./AddUpdate.vue?vue&type=script&lang=js"
export * from "./AddUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddUpdate.vue?vue&type=style&index=0&id=170a617e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports